import { render, staticRenderFns } from "./OrganizationTagSettings.vue?vue&type=template&id=02d607a6&scoped=true"
import script from "./OrganizationTagSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationTagSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTagSettings.vue?vue&type=style&index=0&id=02d607a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d607a6",
  null
  
)

export default component.exports